import React, { Component, createRef } from "react";
import TrabajandoPublicationForm from "./Form";
import { saveTrabajandoPublication } from "./Axios";
import Notifications from "../commons/Notifications";

class StepperForm extends Component {
  constructor(props) {
    super(props);
    const {
      trabajando_publication = {},
      course = {},
      area = {},
      job_type = {},
      company_activity = {},
      work_day = {},
      applicant_profile = {},
      education_level = {},
      education_state = {},
      software_level = {}
    } = this.props;

    const trabajandoFieldData = trabajando_publication.trabajando_field || {};

    this.notificationsRef = createRef();

    this.state = {
      trabajandoPublication: {
        id: { value: trabajando_publication.id || "" },
        title: { value: trabajando_publication.title || "", errors: [] },
        requirements: { value: trabajando_publication.requirements || "", errors: [] },
        trabajandoField: {
          id: trabajandoFieldData.id || null,
          area: {
            value: area ? area.id : trabajandoFieldData.area_id || null,
            label: area ? area.name : trabajandoFieldData.area_name || "",
            errors: []
          },
          job_type: {
            value: job_type ? job_type.id : trabajandoFieldData.job_type_id || null,
            label: job_type ? job_type.name : trabajandoFieldData.job_type_name || "",
            errors: []
          },
          company_activity: {
            value: company_activity ? company_activity.id : trabajandoFieldData.company_activity_id || null,
            label: company_activity ? company_activity.name : trabajandoFieldData.company_activity_name || "",
            errors: []
          },
          work_day: {
            value: work_day ? work_day.id : trabajandoFieldData.work_day_id || null,
            label: work_day ? work_day.name : trabajandoFieldData.work_day_name || "",
            errors: []
          },
          applicant_profile: {
            value: applicant_profile ? applicant_profile.id : trabajandoFieldData.applicant_profile_id || null,
            label: applicant_profile ? applicant_profile.name : trabajandoFieldData.applicant_profile_name || "",
            errors: []
          },
          education_level: {
            value: education_level ? education_level.id : trabajandoFieldData.education_level_id || null,
            label: education_level ? education_level.name : trabajandoFieldData.education_level_name || "",
            errors: []
          },
          education_state: {
            value: education_state ? education_state.id : trabajandoFieldData.education_state_id || null,
            label: education_state ? education_state.name : trabajandoFieldData.education_state_name || "",
            errors: []
          },
          software_level: {
            value: software_level ? software_level.id : trabajandoFieldData.software_level_id || null,
            label: software_level ? software_level.name : trabajandoFieldData.software_level_name || "",
            errors: []
          }
        },
        desactivate_at: { value: trabajando_publication.desactivate_at || "", errors: [] }
      },
      errors: {},
      submitting: false,
      courseId: course.id
    };
  }

  setErrors = errors => {
    const { trabajandoPublication } = this.state;
    trabajandoPublication.trabajandoField.area.errors = errors["area"];
    trabajandoPublication.trabajandoField.job_type.errors = errors["job_type"];
    trabajandoPublication.trabajandoField.company_activity.errors = errors["company_activity"];
    trabajandoPublication.trabajandoField.work_day.errors = errors["work_day"];
    trabajandoPublication.trabajandoField.applicant_profile.errors = errors["applicant_profile"];
    trabajandoPublication.trabajandoField.education_level.errors = errors["education_level"];
    trabajandoPublication.trabajandoField.education_state.errors = errors["education_state"];
    trabajandoPublication.trabajandoField.software_level.errors = errors["software_level"];
    trabajandoPublication.title.errors = errors["trabajando_publication.title"];
    trabajandoPublication.requirements.errors = errors["trabajando_publication.requirements"];
    trabajandoPublication.desactivate_at.errors = errors["trabajando_publication.desactivate_at"];

    this.setState({
      ...this.state,
      trabajandoPublication
    });
  };

  serializeData = () => {
    const { trabajandoPublication } = this.state;
    let formData = new FormData();

    formData.append("trabajando_publication[title]", trabajandoPublication.title.value);
    formData.append("trabajando_publication[requirements]", trabajandoPublication.requirements.value);

    if (trabajandoPublication.trabajandoField.id) {
      formData.append(
        "trabajando_publication[trabajando_field_attributes][id]",
        trabajandoPublication.trabajandoField.id
      );
    }

    formData.append("trabajando_publication[trabajando_field_attributes][area_id]", trabajandoPublication.trabajandoField.area.value);
    formData.append("trabajando_publication[trabajando_field_attributes][job_type_id]", trabajandoPublication.trabajandoField.job_type.value);
    formData.append("trabajando_publication[trabajando_field_attributes][company_activity_id]", trabajandoPublication.trabajandoField.company_activity.value);
    formData.append("trabajando_publication[trabajando_field_attributes][work_day_id]", trabajandoPublication.trabajandoField.work_day.value);
    formData.append("trabajando_publication[trabajando_field_attributes][applicant_profile_id]", trabajandoPublication.trabajandoField.applicant_profile.value);
    formData.append("trabajando_publication[trabajando_field_attributes][education_level_id]", trabajandoPublication.trabajandoField.education_level.value);
    formData.append("trabajando_publication[trabajando_field_attributes][education_state_id]", trabajandoPublication.trabajandoField.education_state.value);
    formData.append("trabajando_publication[trabajando_field_attributes][software_level_id]", trabajandoPublication.trabajandoField.software_level.value);
    formData.append("trabajando_publication[desactivate_at]", trabajandoPublication.desactivate_at.value);

    return formData;
  };

  handleChangeTrabajandoPublication = (e, fieldName = null) => {
    const { trabajandoPublication } = this.state;
    if (fieldName === "is_confidential") {
      trabajandoPublication[fieldName]["value"] = e;
      trabajandoPublication[fieldName]["errors"] = [];
    } else if (fieldName) {
      if (!trabajandoPublication[fieldName]) {
        trabajandoPublication[fieldName] = { value: "", label: "", errors: [] };
      }
      trabajandoPublication[fieldName]["value"] = e.value;
      trabajandoPublication[fieldName]["label"] = e.label;
      trabajandoPublication[fieldName]["errors"] = [];
    } else if (e.target.name === "show_salary") {
      trabajandoPublication[e.target.name]["value"] = e.target.checked;
      trabajandoPublication[e.target.name]["errors"] = [];
    } else {
      trabajandoPublication[e.target.name]["value"] = e.target.value;
      trabajandoPublication[e.target.name]["errors"] = [];
    }

    this.setState({ trabajandoPublication });
  };

  handleChangeTrabajandoFields = (e, fieldName = null) => {
    const { trabajandoPublication } = this.state;
    if (fieldName === "is_confidential") {
      trabajandoPublication["trabajandoField"][fieldName]["value"] = e;
      trabajandoPublication["trabajandoField"][fieldName]["errors"] = [];
    } else if (fieldName) {
      if (!trabajandoPublication["trabajandoField"][fieldName]) {
        trabajandoPublication["trabajandoField"][fieldName] = { value: "", label: "", errors: [] };
      }
      trabajandoPublication["trabajandoField"][fieldName]["value"] = e.value;
      trabajandoPublication["trabajandoField"][fieldName]["label"] = e.label;
      trabajandoPublication["trabajandoField"][fieldName]["errors"] = [];
    } else if (e.target.name === "show_salary") {
      trabajandoPublication["trabajandoField"][e.target.name]["value"] = e.target.checked;
      trabajandoPublication["trabajandoField"][e.target.name]["errors"] = [];
    } else {
      trabajandoPublication["trabajandoField"][e.target.name]["value"] = e.target.value;
      trabajandoPublication["trabajandoField"][e.target.name]["errors"] = [];
    }

    this.setState({ trabajandoPublication });
  };

  handleChangeRequirement = requirements => {
    const { trabajandoPublication } = this.state;
    trabajandoPublication.requirements.value = requirements;
    trabajandoPublication.requirements.errors = [];
    this.setState({ trabajandoPublication });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { trabajandoPublication, courseId } = this.state;
    const requiredTrabajandoFields = [
      "area", "job_type", "company_activity",
      "work_day", "applicant_profile", "education_level", "education_state",
      "software_level"
    ];
    const requiredFields = [
      "title", "requirements", "desactivate_at"
    ];

    let errors = {};
    let errors_field = {};
    let hasError = false;

    requiredFields.forEach(field => {
      const valueObj = trabajandoPublication[field];
      const value = valueObj && typeof valueObj === "object" ? valueObj.value : valueObj;
      if (value === "" || value === null || value === undefined) {
        errors[field] = ["Este campo es obligatorio"];
        hasError = true;
      }
    });

    requiredTrabajandoFields.forEach(field => {
      const valueObj = trabajandoPublication["trabajandoField"][field];
      const value = valueObj && typeof valueObj === "object" ? valueObj.value : valueObj;
      if (value === "" || value === null || value === undefined) {
        errors_field[field] = ["Este campo es obligatorio"];
        hasError = true;
      }
    });

    if (hasError) {
      Object.keys(errors).forEach(field => {
        if (trabajandoPublication[field]) {
          trabajandoPublication[field].errors = errors[field];
        }
      });
      Object.keys(errors_field).forEach(field => {
        if (trabajandoPublication["trabajandoField"][field]) {
          trabajandoPublication["trabajandoField"][field].errors = errors_field[field];
        }
      });
      this.setState({ trabajandoPublication });
      return;
    }

    this.setState({ submitting: true, errors: {} });
    const data = this.serializeData();

    const publicationId = trabajandoPublication.id.value || null;

    saveTrabajandoPublication(
      courseId,
      data,
      response => {
        this.setState({ submitting: false });
        if (response.status === 200 || response.status === 201) {
          trabajandoPublication.id.value = response.data.id;
          this.setState({ ...this.state.trabajandoPublication, trabajandoPublication });
          this.showNotification("Genial", "Información guardada con éxito", "info");
          window.location.href = `/courses/${courseId}/trabajando_publications/${response.data.id}`;
        } else if (response.status === 422) {
          this.setErrors(response.data);
          this.showNotification("Ops", "Ocurrió un error, revisa el formulario", "danger");
        }
      },
      publicationId
    );
  };

  showNotification = (title, message, type) => {
    if (this.notificationsRef.current) {
      this.notificationsRef.current.addNotifications(title, message, type);
    }
  };

  render() {
    return (
      <div>
        <Notifications ref={this.notificationsRef} />
        <TrabajandoPublicationForm
          trabajandoPublication={this.state.trabajandoPublication}
          errors={this.state.errors}
          handleChangeRequirement={this.handleChangeRequirement}
          handleChangeTrabajandoPublication={this.handleChangeTrabajandoPublication}
          handleChangeTrabajandoFields={this.handleChangeTrabajandoFields}
          handleSubmit={this.handleSubmit}
          submitting={this.state.submitting}
        />
      </div>
    );
  }
}

export default StepperForm;